export const cognitoConfig = {
  userPoolId: import.meta.env.VITE_COGNITO_DOCTOR_POOL_ID ?? "placeholder",
  userPoolClientId: import.meta.env.VITE_COGNITO_DOCTOR_CLIENT_ID ?? "placeholder",
  region: import.meta.env.VITE_COGNITO_REGION ?? "me-central-1",
} as const;
